/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wm_Quiz_Finished_Meta_DescriptionInputs */

const de_wm_quiz_finished_meta_description = /** @type {(inputs: Wm_Quiz_Finished_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das WM-Quiz von waipu.tv ist beendet. Vielen Dank fürs Mitspielen!`)
};

/** @type {(inputs: Wm_Quiz_Finished_Meta_DescriptionInputs) => LocalizedString} */
const en_wm_quiz_finished_meta_description = de_wm_quiz_finished_meta_description;

/**

* @param {Wm_Quiz_Finished_Meta_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const wm_quiz_finished_meta_description = /** @type {((inputs?: Wm_Quiz_Finished_Meta_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wm_Quiz_Finished_Meta_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_wm_quiz_finished_meta_description(inputs)
	return en_wm_quiz_finished_meta_description(inputs)
});